<ng-content></ng-content>
<span *ngIf="showDivider"
  class="balloon-divider"></span>
